import { HighlightedText } from '@/components/why-prepsolution/HighlightedText'
import { cn } from '@/lib/utils'

interface AdaptiveCopyProps {
  content: string
  className?: string
}

/**
 * Renders one paragraph of adaptive-learning copy: {{...}} spans become
 * highlighted text, inline **...** spans become bold ink emphasis.
 */
export function AdaptiveCopy({ content, className }: AdaptiveCopyProps) {
  const parts: string[] = content.split(/\*\*(.*?)\*\*/)

  return (
    <p
      className={cn(
        'text-body text-sm leading-relaxed md:text-base',
        className
      )}
    >
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i} className="text-ink font-bold">
            <HighlightedText text={part} />
          </strong>
        ) : (
          <HighlightedText key={i} text={part} />
        )
      )}
    </p>
  )
}
